import { connect } from 'react-redux'
import AdLibraryActions from '../redux/AdLibraryRedux'
import AdLibraryComponent from '../components/AdLibraryComponent'

// Connects the isolated Ad Library store to the presentational component.
// react-redux is v6 (no hooks) so the project uses connect() containers.
const mapStateToProps = ({
  ads,
  adsTotal,
  folders,
  selectedIds,
  selectedTag,
  clients,
  loadingClients,
  loadingAds,
  loadingFolders,
  uploading,
  uploadProgress,
  folderSubmitting,
  folderError,
}) => ({
  ads,
  adsTotal,
  folders,
  selectedIds,
  selectedTag,
  clients,
  loadingClients,
  loadingAds,
  loadingFolders,
  uploading,
  uploadProgress,
  folderSubmitting,
  folderError,
})

const mapDispatchToProps = (dispatch) => ({
  toggleSelect: (id) => dispatch(AdLibraryActions.toggleSelect(id)),
  clearSelection: () => dispatch(AdLibraryActions.clearSelection()),
  selectAll: (ids) => dispatch(AdLibraryActions.selectAll(ids)),

  getTags: (scope) => dispatch(AdLibraryActions.getTagsRequest(scope)),
  getContents: (scope, tag, search, types, page, sort) =>
    dispatch(AdLibraryActions.getContentsRequest(scope, tag, search, types, page, sort)),
  setSelectedTag: (tag) => dispatch(AdLibraryActions.setSelectedTag(tag)),

  renameAd: (id, name) => dispatch(AdLibraryActions.renameAdRequest(id, name)),
  deleteAds: (ids) => dispatch(AdLibraryActions.deleteAdsRequest(ids)),
  uploadAds: (files, meta) => dispatch(AdLibraryActions.uploadAdsRequest(files, meta)),

  createFolder: (name, parentId) => dispatch(AdLibraryActions.createFolderRequest(name, parentId)),
  renameFolder: (id, name, parentId) => dispatch(AdLibraryActions.renameFolderRequest(id, name, parentId)),
  // Bulk logical delete (one or many) via PUT /contents-tags/archive { ids }.
  deleteFolders: (ids) => dispatch(AdLibraryActions.deleteFoldersRequest(ids)),

  getClients: (userId, search) => dispatch(AdLibraryActions.getClientsRequest(userId, search)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AdLibraryComponent)
